export default class FetchUserPermissions {
	constructor(public readonly userId: number) {
		Object.freeze(this);
	}
}
